import './Block.css';
import React from 'react';


function Block(props) {
  const blockstyle = {
    // backgroundImage: props.image ? 'url("./pointwave.webp")' : null,
    // height: props.height ? props.height : null,
    backgroundColor: props.colorTheme === "light" ? "white" : "#2a2829",
    color: props.colorTheme === "light" ? "black" : "white",
    display: "grid",
    gridTemplateColumns: window.innerWidth <= 1200 ? window.innerWidth : props.gridTemplateColumns,
    // gridGap: "10px",
    // display: window.innerWidth < 767 ? "grid" : "flex"
  };

 
  return (
    <div className="Block" style={blockstyle}>
      {props.children}
      {/* {updatedChildren} */}
    </div>

  );
}

export default Block;
